module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="useFiltersBnr">\r\n	<div class="useFiltersBnr__container">\r\n		<div class="banner-close" data-banner="Фильтры_закрыть" data-index="'+
((__t=(hotelIndex))==null?'':__t)+
'">\r\n			<i class="icon icon-i16_close"></i>\r\n		</div>\r\n		' + require("./parts/search__use-filter-bnr.phtml").apply(null,arguments) + '\r\n	</div>\r\n</div>';
}
return __p;
};
